import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("h1", [_vm._v("Sign Up Links")]), _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-top-buttons"
  }, [_vm.canManage ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.addNewLink();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" New link ")], 1) : _vm._e()], 1)]), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --no-hover",
    attrs: {
      headers: _vm.headers,
      items: _vm.links,
      "item-key": "id",
      loading: _vm.loadings.datatable,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function fn() {
        return [_vm._v("You do not have any links, create new ones.")];
      },
      proxy: true
    }, {
      key: "item.name",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm.isEditing(item) ? _c("div", {
          staticClass: "d-flex align-center"
        }, [_c(VTextField, {
          staticClass: "mr-2",
          attrs: {
            dense: "",
            "hide-details": ""
          },
          on: {
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.saveEdit(item, "name");
            }
          },
          model: {
            value: _vm.editingName,
            callback: function callback($$v) {
              _vm.editingName = $$v;
            },
            expression: "editingName"
          }
        }), _c(VIcon, {
          staticClass: "mr-1",
          attrs: {
            small: "",
            disabled: _vm.isSavingEdit,
            title: "Save"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.saveEdit(item, "name");
            }
          }
        }, [_vm._v(" mdi-check ")]), _c(VIcon, {
          attrs: {
            small: "",
            disabled: _vm.isSavingEdit,
            title: "Cancel"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.cancelEdit.apply(null, arguments);
            }
          }
        }, [_vm._v(" mdi-close ")])], 1) : _c("div", [_vm._v(" " + _vm._s(item.name) + " "), _c(VIcon, {
          staticClass: "ml-2",
          attrs: {
            small: "",
            disabled: _vm.loadings.datatable,
            title: "Edit"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.startEdit(item);
            }
          }
        }, [_vm._v(" mdi-pencil ")])], 1)];
      }
    }, {
      key: "item.utmSource",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm.isEditingUtm(item) ? _c("div", {
          staticClass: "d-flex align-center"
        }, [_c(VTextField, {
          staticClass: "mr-2",
          attrs: {
            dense: "",
            "hide-details": ""
          },
          on: {
            input: _vm.sanitizeUtmSource,
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.saveEdit(item, "utmSource");
            }
          },
          model: {
            value: _vm.editingUtmSource,
            callback: function callback($$v) {
              _vm.editingUtmSource = $$v;
            },
            expression: "editingUtmSource"
          }
        }), _c(VIcon, {
          staticClass: "mr-1",
          attrs: {
            small: "",
            disabled: _vm.isSavingEdit,
            title: "Save"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.saveEdit(item, "utmSource");
            }
          }
        }, [_vm._v(" mdi-check ")]), _c(VIcon, {
          attrs: {
            small: "",
            disabled: _vm.isSavingEdit,
            title: "Cancel"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.cancelUtmEdit.apply(null, arguments);
            }
          }
        }, [_vm._v(" mdi-close ")])], 1) : _c("div", [_vm._v(" " + _vm._s(item.utmSource) + " "), _c(VIcon, {
          staticClass: "ml-2",
          attrs: {
            small: "",
            disabled: _vm.loadings.datatable,
            title: "Edit"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.startUtmEdit(item);
            }
          }
        }, [_vm._v(" mdi-pencil ")])], 1)];
      }
    }, {
      key: "item.link",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("a", {
          attrs: {
            href: item.link,
            target: "_blank"
          }
        }, [_vm._v(_vm._s(item.link))]), _c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref4) {
              var on = _ref4.on,
                attrs = _ref4.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                staticClass: "ml-2",
                attrs: {
                  small: "",
                  disabled: _vm.isCopyingToClipboard,
                  title: "Copy to clipboard"
                },
                on: {
                  click: function click($event) {
                    return _vm.copyToClipboard(item.link);
                  }
                }
              }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
            }
          }], null, true)
        }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
          staticStyle: {
            color: "green"
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.createdAt)) + " ")];
      }
    }, {
      key: "item.createdBy",
      fn: function fn(_ref6) {
        var _item$createdBy, _item$createdBy2, _item$createdBy3;
        var item = _ref6.item;
        return [_c("div", {
          staticClass: "d-flex flex-column text-smaller"
        }, [_c("span", [_vm._v(" " + _vm._s((_item$createdBy = item.createdBy) === null || _item$createdBy === void 0 ? void 0 : _item$createdBy.login) + " ")]), _c("router-link", {
          attrs: {
            to: _vm.goToUserPage(item.createdBy),
            target: "_blank"
          }
        }, [_vm._v(" " + _vm._s((_item$createdBy2 = item.createdBy) === null || _item$createdBy2 === void 0 ? void 0 : _item$createdBy2.name) + " " + _vm._s((_item$createdBy3 = item.createdBy) === null || _item$createdBy3 === void 0 ? void 0 : _item$createdBy3.nickname) + " ")])], 1)];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c("div", {
          staticClass: "table-actions"
        }, [!_vm.hasUsed(item) ? _c(VIcon, {
          attrs: {
            small: "",
            disabled: _vm.loadings.datatable,
            title: "Delete"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.deleteItem(item);
            }
          }
        }, [_vm._v(" mdi-delete ")]) : _vm._e()], 1)];
      }
    }], null, true)
  })], 1), _c("UserSignupLinkCreateDrawer", {
    on: {
      linkCreated: _vm.onLinkCreated
    },
    model: {
      value: _vm.showCreateDrawer,
      callback: function callback($$v) {
        _vm.showCreateDrawer = $$v;
      },
      expression: "showCreateDrawer"
    }
  }), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };